var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-invoice-node-sidebar"},[_c('inactive-input',{model:{value:(_vm.inactiveTime),callback:function ($$v) {_vm.inactiveTime=$$v},expression:"inactiveTime"}}),(_vm.inactiveTime > 0)?_c('switch-input',{attrs:{"setup":{
      'func': _vm.switchInactiveRemove,
      'args': {
        'model': _vm.node.data,
        'key': 'inactive_remove',
        'prefix': 'send_invoice_',
      }
    }}}):_vm._e(),_c('create-if-empty',{attrs:{"options":_vm.cashRegistersOptions,"empty-message":_vm.$t('pi_cash_register_create_empty_message')},on:{"onCreateClick":_vm.handleCashRegisterOption}},[_c('select-input',{attrs:{"setup":{
        'func': _vm.setCashRegister,
        'args': {
          'model': _vm.node.data,
          'key': 'cash_register_id',
          'options': _vm.cashRegistersOptions,
          'taggable': true,
          'clearable': false,
          'prefix': 'send_invoice_',
          'notFoundOptionText': _vm.$t('cash_register_not_found').toString(),
          'createButton': {
            'title': _vm.$t('create_cash_register').toString(),
            'callback': _vm.handleCashRegisterOption
          },
        }
      }}})],1),(_vm.selectedCashRegister && !_vm.selectedCashRegister.valid)?_c('div',{staticClass:"mx-2 text-center"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('cash_register_open_update_warning_title'))+" ")]),_c('a-button',{attrs:{"icon":"edit","type":"danger"},on:{"click":function($event){_vm.activeCashRegisterId = _vm.node.data.cash_register_id}}},[_vm._v(" "+_vm._s(_vm.$t('cash_register_open_update_modal_button_title'))+" ")]),_c('cash-register-editor',{attrs:{"core":_vm.node.nodeProps.cashRegisterLogic},model:{value:(_vm.activeCashRegisterId),callback:function ($$v) {_vm.activeCashRegisterId=$$v},expression:"activeCashRegisterId"}})],1):_vm._e(),_c('create-if-empty',{attrs:{"options":_vm.node.data.cash_register_id ? _vm.productsOptions : null,"empty-message":_vm.$t('pi_product_create_empty_message')},on:{"onCreateClick":_vm.handleProductOption}},[_c('select-input',{attrs:{"setup":{
        'func': _vm.setProduct,
        'args': {
          'model': _vm.node.data,
          'key': 'product_id',
          'options': _vm.productsOptions,
          'taggable': true,
          'clearable': false,
          'prefix': 'send_invoice_',
          'disabled': !_vm.node.data.cash_register_id || !_vm.selectedCashRegister,
          'createButton': {
            'title': _vm.$t('create_product'),
            'callback': _vm.handleProductOption
          },
          'notFoundOptionText': _vm.$t('product_not_found'),
        }
      }}})],1),[_c('select-input',{attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': this,
          'key': 'countType',
          'prefix': 'send_invoice_node_sidebar_',
          'options': _vm.countTypes,
          'clearable': false,
        }
      }},on:{"input":_vm.onCountTypeChange}}),_c('nested-content',[(_vm.node.data.count.type === 'Constant')?_c('number-input',{staticClass:"mt-0 mb-0",attrs:{"setup":{
          'func': _vm.constantCountSetter,
          'args': {
            'model': _vm.node.data.count,
            'key': 'value',
            'prefix': 'send_invoice_node_sidebar_count_constant_',
            'defaultValue': 1,
            'min': 1,
            'settingWrapper': {
              hasFieldButton: true,
              disabledValue: 1,
              customiseValue: 2
            },
          },
        }}}):_vm._e(),(_vm.node.data.count.type === 'Calculate')?_c('config-field',{attrs:{"title":_vm.$t('field_send_invoice_node_sidebar_count_calculate_value_title'),"mini-help-message":_vm.$t('field_send_invoice_node_sidebar_count_calculate_value_mini_help_message')}},[_c('formula-input',{staticClass:"py-1",attrs:{"mention-items":_vm.formulaProperties},model:{value:(_vm.node.data.count.value),callback:function ($$v) {_vm.$set(_vm.node.data.count, "value", $$v)},expression:"node.data.count.value"}})],1):_vm._e()],1)],[_c('switch-input',{attrs:{"setup":{
        'func': _vm.switchDiscount,
        'args': {
          'model': _vm.context,
          'key': 'discountExist',
          'prefix': 'flow_send_invoice_'
        }
      }}}),(_vm.node.data.discount)?_c('nested-content',[_c('config-field',{attrs:{"title":_vm.$t('field_send_invoice_discount_formula_title'),"mini-help-message":_vm.$t('field_send_invoice_discount_formula_mini_help_message')}},[_c('formula-input',{staticClass:"py-1",attrs:{"mention-items":_vm.formulaProperties},model:{value:(_vm.discount),callback:function ($$v) {_vm.discount=$$v},expression:"discount"}})],1)],1):_vm._e()],_c('cash-register-setup',{attrs:{"visible":_vm.newCashRegister.isOpen,"initial-name":_vm.newCashRegister.initName,"create-cash-register":function (system) { return _vm.node.nodeProps.cashRegisterLogic && _vm.node.nodeProps.cashRegisterLogic.createCashRegisterHandler(system); }},on:{"update:visible":function($event){return _vm.$set(_vm.newCashRegister, "isOpen", $event)},"input-cash-register":function (ref) {
          var id = ref.id;

          return _vm.node.setCashRegister(id);
}}}),_c('create-new-product',{attrs:{"initial-name":_vm.newProduct.initName,"target-id":_vm.node.nodeProps.target,"create-product":function (product) { return _vm.node.nodeProps.createProduct(product); }},on:{"input-product":function (ref) {
          var id = ref.id;

          return _vm.node.setProduct(id);
}},model:{value:(_vm.newProduct.isOpen),callback:function ($$v) {_vm.$set(_vm.newProduct, "isOpen", $$v)},expression:"newProduct.isOpen"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }